import React from "react";
import Button from "../../ui/button/button";
import Icon from "../../ui/icon/icon";
import { logout } from "../../../../utils/logout";
import './logoutButton.css';

export default function LogoutButton({
    type='primary',
    title,
    icon=null,
    fluid=false,
    contextLogout='stepHeader',
    storage,
    config
}) {
    const _title = config?.logout_button?.title || title;
    const _type = config?.logout_button?.type || type;

    const _onDisconnect = React.useCallback(() => {
        return logout(contextLogout, storage)
    }, [storage, contextLogout]);

    return (
        <div className='logout-button-container'>
            <Button className='neo-logout-button' type={_type} onClick={_onDisconnect} fluid={fluid} label={
                <>
                    {icon && <Icon name={icon} />}
                    <span className='neo-logout-button-text'>{_title}</span>
                </>
            }/>
        </div>
    )
}